import { Label } from "expano-components";
import { MainList, Main } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import { sort, filters } from "./const/data";
import LazyLoad from "react-lazy-load";

const ProductGroupList = ({ history }) => (
  <Main
    page={{
      name: "Zarządzanie produktami",
      icon: <ShopIcon />,
      breadcrumbs: [
        {
          name: "Zarządzanie produktami",
        },
      ],
    }}
  >
    <MainList
      query_key="product_groups"
      api_path="/product_groups"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      handleNavigate={(item) =>
        history.push(`/products_manage/product_groups/${item.id}`)
      }
      renderItem={({
        name,
        sku,
        global_image_url,
        root_taxon,
        producer,
        brand,
        channels,
      }) => (
        <>
          <td>
            {global_image_url && (
              <LazyLoad height={40}>
                <img
                  alt={name}
                  src={global_image_url}
                  style={{
                    width: 40,
                    height: 40,
                  }}
                />
              </LazyLoad>
            )}
          </td>
          <td>{name}</td>
          <td>{sku}</td>
          <td>{root_taxon?.name}</td>
          <td>{producer?.name}</td>
          <td>{brand?.name}</td>
          <td>
            <div style={{ display: "flex", gap: "13px 0", flexFlow: "wrap" }}>
              {channels
                ?.sort((a, b) => a.id - b.id)
                ?.map(({ id, shop, platform }) => (
                  <span key={id} style={{ whiteSpace: "nowrap" }}>
                    <Label
                      type="double"
                      left={{
                        text: shop?.label_text,
                        color: `#${shop?.label_color}`,
                      }}
                      right={{
                        text: platform?.label_text,
                        color: `#${platform?.label_color}`,
                      }}
                    />
                  </span>
                ))}
            </div>
          </td>
        </>
      )}
    />
  </Main>
);

export default ProductGroupList;
